export const API_PATH = {
  TC: 'tc',
  TAG: '/tag',
  UOM: '/uom',
  USER: '/user',
  TASK: '/task',
  MENU: '/menu',
  ROLE: '/role',
  PLANT: '/plant',
  REPORT: '/report',
  COMPANY: '/company',
  LICENSE: '/license',
  TAG_TYPE: '/tag-type',
  DISCIPLINE: '/discipline',
  ANNOUNCEMENT: '/announcement',
  COMPANY_GROUP: '/company-group',
  AUTHENTICATION: 'authentication',
  ATTRIBUTE_GROUP: '/attribute-group',
  GENERAL_ATTRIBUTE_GROUP: '/general-attribute-group',
  CONFIGURATION: '/configuration',
}
